{
  "name": "client-portal-alphastar",
  "version": "0.0.0",
  "scripts": {
    "api-gen": "ng-openapi-gen --input openapi-dynamic-form.yaml --output src/app/api/dynamic-form",
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "eslint src",
    "prettier": "npx prettier --write .",
    "prepare": "husky install"
  },
  "lint-staged": {
    "*.{ts,tsx}": [
      "npm run prettier"
    ],
    "*.html": [
      "npm run prettier"
    ],
    "*.scss": "npm run prettier"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.18",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.18",
    "@angular/compiler": "^19.2.18",
    "@angular/core": "^19.2.18",
    "@angular/forms": "^19.2.18",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.18",
    "@angular/platform-browser-dynamic": "^19.2.18",
    "@angular/router": "^19.2.18",
    "@auth0/angular-jwt": "^5.2.0",
    "@ng-select/ng-select": "^11.1.1",
    "admin-lte": "^3.2.0",
    "ng-otp-input": "^1.9.3",
    "ngx-toastr": "^17.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "overrides": {
    "autoprefixer": "10.4.5"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular-eslint/builder": "19.0.2",
    "@angular-eslint/eslint-plugin": "19.0.2",
    "@angular-eslint/eslint-plugin-template": "19.0.2",
    "@angular-eslint/schematics": "19.0.2",
    "@angular-eslint/template-parser": "19.0.2",
    "@angular/cli": "~19.2.19",
    "@angular/compiler-cli": "^19.2.18",
    "@types/jasmine": "~4.3.0",
    "@typescript-eslint/eslint-plugin": "5.62.0",
    "@typescript-eslint/parser": "5.62.0",
    "eslint": "^8.47.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-prettier": "^5.0.0",
    "husky": "^8.0.0",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^14.0.1",
    "ng-openapi-gen": "^0.25.1",
    "prettier": "^3.0.2",
    "prettier-eslint": "^15.0.1",
    "typescript": "~5.8.3"
  }
}
